module.exports = __webpack_public_path__ + "6b1d15633ef154b1f89e4d5ec1a2571b.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/chloe/start.png
// module id = 129
// module chunks = 0